import {IController, IModule, IOnChangesObject} from "angular";
import {l} from "types/typescriptdefinisjoner_lederplan";
import {dersomChangesInneholder} from "felles/stoettefunk/angularHjelpemetoder";
import {Debugger} from "debug";
import {DokumentsigneringRessurs} from "../../../../../felles/tjenester/ressurser/DokumentsigneringRessurs";
import {DokumentsigneringTjeneste} from "../../../../../felles/tjenester/modulspesifikke/DokumentsigneringTjeneste";
import {SendPåminelseOmSigneringDialog} from "../../modale/sendPåminelseOmSignering/sendPåminelseOmSigneringDialog";
import {regNavn} from "../../../../../felles/tjenester/tredjepartsTjenestenavn";
import {gettextCatalog} from "angular-gettext";

const debug: Debugger = require('debug')('ListeDokumenterSomManglerSignaturerKontroller');
const css = require('./visSignaturstatus.scss');

export class VisSignaturstatusKontroller implements IController {

    static skjultTipsRegister: { [møteId: string]: boolean } = {};

    static registrerKomponent(angular: IModule) {
        angular
          .component('wmVisSignaturstatus', {
              bindings: {dokumentId: '<'},
              controller: VisSignaturstatusKontroller.forInjisering(),
              template: require('./visSignaturstatus.html')
          });
    }

    static forInjisering() {
        return [
            regNavn.md.$mdDialog,
            DokumentsigneringRessurs.regNavn,
            DokumentsigneringTjeneste.regNavn,
            regNavn.gettext.gettextCatalog,
            VisSignaturstatusKontroller
        ];
    }

    constructor(private $mdDialog: angular.material.IDialogService,
                private dokumentsigneringRessurs: DokumentsigneringRessurs,
                private dokumentsigneringTjeneste: DokumentsigneringTjeneste,
                private gettextCatalog: gettextCatalog) {
    }

    dokumentId: string; //settes via bindings/$onChanges

    signatarer: l.DokumentSignatarerModell;
    antallIkkeSignert = 0;
    lastet = false;

    signeringsinformasjon(signatar: l.DokumentSignatarModell) {
        return this.dokumentsigneringTjeneste.signaturinformasjonSomTekst(signatar.signaturinformasjon);
    }

    purringSendeOmAntallDager(){
        if (!this.signatarer) return '';
        return this.signatarer.dagerTilNestePurring == 0 ?
          this.gettextCatalog.getString('i dag') :
          this.gettextCatalog.getString('om {{antall}} dager', {antall: this.signatarer.dagerTilNestePurring});
    }

    sendPaaminelse(){
        SendPåminelseOmSigneringDialog.visSendPåminelseOmSigneringDialog(this.dokumentId, this.$mdDialog)
    }

    $onChanges(changes: IOnChangesObject): void {
        dersomChangesInneholder(changes, 'dokumentId',
          dokumentId => this.lastData());
    }


    //hjelpemetoder

    private lastData() {
        this.dokumentsigneringRessurs.signatarer(this.dokumentId).$promise
          .then(signatarer => this.signatardetaljerLastet(signatarer));
    }

    private signatardetaljerLastet(signatarer: l.DokumentSignatarerModell) {
        this.signatarer = signatarer;
        this.antallIkkeSignert = this.signatarer.signatarer.filter(s => !s.harSignert).length;
        this.lastet = true;
    }
}
